<template>
  <div>
  </div>
</template>

<script>
export default {
    props : ["selectedScreenName","showAddCustomKeyButton","componentname"],
    data(){
        return{
            add:"Add",
        }
    },
    components: {
  },
    methods:{
        changeToSelectedScreensTableComponent(compName, payload = {}){
            this.$emit("changeToSelectedScreensTableComponent", compName, payload)
        }
    }
}
</script>

<style scoped lang="scss">
$header-background: #1a1a1a;
$border-color: 1px solid #3a3a3a;
$background: #121212;
$bg-color-on-hover: #141414;
$body-bg-color: #0d0d0d;
$dull-text-color: #757575;
$options-text-color: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$active-blue : #007bff;


.comm-settings-top-nav{
    background: transparent;
}

.btn{
    height:100%;
}

.breadcrumb{
  padding: .75rem 1rem !important;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}

.primary-btn-style{
    margin-top:1%;
    button{
        height: 35px;
        width: 70px;
        float: inline-end;
        margin-inline-end: 25px;
    font-size:14px;
    }
}
</style>